import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/sign-up-apple-white.svg'


const _hoisted_1 = { class: "button__text d-none d-md-inline" }
const _hoisted_2 = { class: "button__text d-md-none" }

import { AppleNativeAuthView } from '@/models/auth/apple.native'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppleSignInButton',
  props: {
    view: {},
    title: {}
  },
  setup(__props: any) {

const props = __props

async function login(): Promise<void> {
  await props.view.start()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([__props.view.isEnabled ? '' : 'disabled', "button button--black appleSignIn shortform-sign-up__button"]),
    onClick: login
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "button__img",
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title) + " Apple", 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title) + " Apple", 1)
  ], 2))
}
}

})